import type { Bo4eFieldInfo } from "@/api/mapperApi";

const MONO = "var(--sapFontMonoFamily, monospace)";
const LABEL = "var(--sapContent_LabelColor)";
const BORDER = "var(--sapList_BorderColor)";

const MAX_CHIPS = 8;

function Chip({ children }: { children: React.ReactNode }) {
  return (
    <span
      style={{
        display: "inline-block",
        border: `1px solid ${BORDER}`,
        borderRadius: "3px",
        padding: "0 5px",
        margin: "2px 4px 0 0",
        fontFamily: MONO,
        fontSize: "0.7rem",
        whiteSpace: "nowrap",
      }}
    >
      {children}
    </span>
  );
}

export function Bo4eZielDoc({
  info,
  align = "right",
}: {
  info: Bo4eFieldInfo;
  align?: "left" | "right";
}): JSX.Element | null {
  if (!info.found) {
    return (
      <div
        data-testid="bo4e-ziel-doc"
        style={{
          display: "inline-block",
          textAlign: align,
          fontSize: "0.72rem",
          color: LABEL,
        }}
      >
        keine Schema-Doku
      </div>
    );
  }

  const typeLabel = info.type || info.enum_name;
  const description = info.description || info.enum_description;
  const values = info.enum ?? [];
  const shown = values.slice(0, MAX_CHIPS);
  const rest = values.length - shown.length;

  return (
    <div data-testid="bo4e-ziel-doc" style={{ display: "inline-block", textAlign: align }}>
      <div style={{ fontFamily: MONO, fontWeight: 600, fontSize: "0.82rem", textAlign: align }}>
        {info.bo + "." + info.path}
      </div>
      {typeLabel && (
        <div style={{ fontSize: "0.72rem", color: LABEL, textAlign: align }}>Typ: {typeLabel}</div>
      )}
      {description && (
        <div style={{ fontSize: "0.74rem", color: LABEL, textAlign: align }}>{description}</div>
      )}
      {values.length > 0 && (
        <div style={{ textAlign: align }}>
          <div style={{ fontSize: "0.7rem", color: LABEL, textAlign: align }}>
            Mögliche Werte ({values.length})
          </div>
          <div>
            {shown.map((v) => (
              <Chip key={v}>{v}</Chip>
            ))}
            {rest > 0 && <Chip>+ {rest} weitere</Chip>}
          </div>
        </div>
      )}
    </div>
  );
}
